import { render, staticRenderFns } from "./GlobalClassifiedSearch.vue?vue&type=template&id=bae1b622&"
import script from "./GlobalClassifiedSearch.vue?vue&type=script&lang=js&"
export * from "./GlobalClassifiedSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports